import {createElement, Component, PropTypes} from 'rlink-react';

import $ from 'jquery';

import SelectInput from 'rlink-forms/inputs/SelectInput';
import RadioGroupInput from 'rlink-forms/inputs/RadioGroupInput';

import FormComponent from 'rlink-forms/redux/FormComponent';

import inspectableError from 'rlink-inspectable-error';

import parseLocaleString from 'rlink-regions/parseLocaleString';
import getLabelFromCountryCode from 'rlink-regions/getLabelFromCountryCode';

import themeable from 'rlink-theme/themeable';

import getLabelFromLanguage from 'rlink-regions/getLabelFromLanguage';

import defaultTheme from 'rlink-regions/components/RegionPicker.less';
import fontAwesome from 'rlink-lesscore/icons/font-awesome.less';


export default class RegionPicker extends FormComponent {


  componentDidMount () {
    if (this.props.type === RegionPicker.renderTypes.MAP_RADIO) {
      this.setupMapPicker();
    }
  }

  setupMapPicker () {
    global.jQuery = $;
    //require('jvectormap-next/jquery-jvectormap.css');
    // require('jvectormap-next');
    // require('jvectormap-next/tests/assets/jquery-jvectormap-world-mill-en.js');

    this.jVectorMap = $(this.worldMap).vectorMap(this.mapSettings());
  }

  mapSettings () {
    let mapSettings = Object.assign(this.props.mapSettingsOverride, this.props.mapSettings);
    global.zoomStep = this.props.mapSettings.zoomStep;

    mapSettings.selectedRegions = this.props.country;


    mapSettings.onRegionSelected = (ev, code, isSelected, selectedRegions) => {
      if (selectedRegions.length > 0) {
        this.updateCountry(Object.assign(ev, {
          value: selectedRegions[0],
        }));
      }
    };

    return mapSettings;
  }

  componentDidUpdate (prevProps, prevState) {
    if (this.props.type === RegionPicker.renderTypes.MAP_RADIO
      && this.state
      && this.state.showPicker === true
      && (!prevState || prevState.showPicker === false)) {
      $(this.worldMap).vectorMap(this.mapSettings());
    }
  }

  showRegionPicker () {
    if (!this.state || !this.state.showPicker) {
      this.setState({showPicker: true});
      this._closeRegionPicker = ev => this.closeRegionPicker(ev);
      document.addEventListener('click', this._closeRegionPicker);

    }
  }

  closeRegionPicker (ev) {
    if (!this._regionPicker.contains(ev.target)) {
      this.setState({showPicker: false});
      document.removeEventListener('click', this._closeRegionPicker);
    }
  }


  updateCountry (ev) {
    this.props.onUpdateCountry(ev);
  }

  updateReadingLanguage (ev) {
    let event = ev;
    if (ev.value === '_EMPTY_VALUE_') {
      event = Object.assign(event, {
        value: (this.props.languages.length > 0)
          ? this.props.languages[0].value
          : this.props.choices[0].value,
      });
    }

    this.props.onUpdateReadingLanguage(event);
  }

  sortChoices (choices, languages) {
    choices.sort((prev, next) => {
      let prevScore = this.props.sortBy.length;
      let nextScore = this.props.sortBy.length;
      for (let [priority, sortBy] of this.props.sortBy.entries()) {
        switch (sortBy) {
          case RegionPicker.sortTypes.ALPHABETICAL:
            prevScore = prev.value.toLowerCase();
            nextScore = next.value.toLowerCase();
            break;
          case RegionPicker.sortTypes.BEST_MATCH:
            for (let bestMatch of languages) {
              if (prev.value === bestMatch.value) {
                prevScore = priority;
              }

              if (next.value === bestMatch.value) {
                nextScore = priority;
              }
            }
            break;
          case RegionPicker.sortTypes.VALUE_LANGUAGE:
            if (this.props.readingLanguage) {
              if (parseLocaleString(prev.value).languageCode
                === parseLocaleString(this.props.readingLanguage).languageCode) {
                prevScore = priority;
              }

              if (parseLocaleString(next.value).languageCode
                === parseLocaleString(this.props.readingLanguage).languageCode) {
                nextScore = priority;
              }
            }
            break;
          case RegionPicker.sortTypes.VALUE_ALWAYS_FIRST:
            if (prev.value === this.props.readingLanguage) {
              return -1;
            }

            if (next.value === this.props.readingLanguage) {
              return 1;
            }
          default:
            throw inspectableError`Invalid sort type specified in RegionPicker, you passed [${Object.keys(this.props.sortBy).toString(', ')}] acceptable sort types are [${Object.keys(RegionPicker.sortTypes).toString(', ')}]`;
        }
      }

      if (prevScore < nextScore) {
        return -1;
      }

      if (prevScore > nextScore) {
        return 1;
      }

      return 0;
    });
  }

  formattedChoices () {
    let choices = this.props.choices, languages = [];
    if (this.props.useFlags) {
      for (let match of this.props.languages) {
        choices = choices.filter(a =>
          (a.value !== match.value)
        );

        let region = parseLocaleString(match.value);
        languages.push(Object.assign(match, {
          classNames: ['Flag', region.countryCode.toLowerCase()],
        }));
      }
    }

    if (this.props.sortBy.length > 0) {
      this.sortChoices(choices, languages);
    }

    return {
      choices,
      languages,
    };
  }

  showDropdownFlag (choices) {
    for (let choice of choices) {
      if (this.props.readingLanguage === choice.value) {
        return true;
      }
    }

    return false;
  }

  getPlaceholder (languages) {
    return (this.props.showPlaceholder)
      ? (languages.length > 0 && this.props.useFlags)
        ? 'Other'
        : 'Please select a region'
      : false;
  }

  toggleCollapse (ev, collapsible) {
    this.props.onToggleCollapse({
      collapsible: collapsible,
      ...ev,
    });

  }

  renderTogglable () {
    let caret = (this.state && this.state.showPicker)
      ? 'fa-caret-up'
      : 'fa-caret-down'
      ;
    let renderLanguage = !(this.props.type === RegionPicker.renderTypes.COUNTRY_RADIO);
    return <div>
      <a className={this.props.theme.RegionPickerToggle} onClick={ev => this.showRegionPicker()}>
        <span className={`${fontAwesome.fa} ${fontAwesome['fa-globe']} ${fontAwesome['fa-lg']} ${this.props.theme.Icon}`} />
        <span>{getLabelFromCountryCode(this.props.country)}</span>
        {(renderLanguage) && <span>{` - ${getLabelFromLanguage(this.props.language)}`}</span>}
        <span className={`${fontAwesome.fa} ${fontAwesome[caret]} ${fontAwesome['fa-lg']} ${this.props.theme.Icon}`} />
      </a>
      <div className={`${this.props.theme.RegionPickerPopupWrapper} ${(this.state && this.state.showPicker)
        ? this.props.theme.RegionPickerActive
        : this.props.theme.RegionPickerInactive}`}
        ref={regionPicker => this._regionPicker = regionPicker}>

        <div className={`${this.props.theme.RegionPickerPopup}`}>
          {this.renderRegionPicker()}
        </div>
      </div>
    </div>;
  }

  renderMapRadio () {
    return <div className={this.props.theme.RegionPicker}>
      <div className={this.props.theme.MapPicker}>
        <div className={this.props.theme.WorldMap}
          ref={div => {
            this.worldMap = div;
          }} />
      </div>
      <div className={`${this.props.theme.LanguagePicker}`}>
        <RadioGroupInput
          choices={this.props.languages.map(language => ({
            value: language,
            label: getLabelFromLanguage(language),
          }))}
          {...this.inputProps('flagChoice')}
          value={this.props.readingLanguage}
          onChange={ev => this.updateReadingLanguage(ev)}
          theme={this.props.theme} />
      </div>
    </div>;
  }

  renderRadioDropdown () {
    return <div className={this.props.theme.RegionPicker}>
      {(this.props.useFlags && languages.length > 0)
        && <div className={`${this.props.theme.FlagPicker} ${this.props.theme.F32}`}>
          <RadioGroupInput
            choices={languages}
            {...this.inputProps('flagChoice')}
            value={this.props.readingLanguage}
            onChange={ev => this.updateReadingLanguage(ev)}
            theme={this.props.theme} />
        </div>
      }
      {this.showDropdownFlag(choices)
        && <div className={`${this.props.theme.DropdownFlag} ${this.props.theme.F32}`}>
          <div className={`${this.props.theme.Flag}
            ${this.props.theme[parseLocaleString(this.props.readingLanguage).countryCode.toLowerCase()]}`} />
        </div>
      }
      <div className={`${this.props.theme.DropdownContainer}
        ${(dropdownPicked) ? this.props.theme.Selected : ''}`}>
        <SelectInput
          {...this.inputProps('dropdownChoice')}
          placeholder={this.getPlaceholder(languages)}
          required={(languages.length === 0)}
          choices={choices}
          onChange={ev => this.updateReadingLanguage(ev)}
          value={this.props.readingLanguage} />
      </div>
    </div>;
  }

  renderDoubleRadio () {
    return <div className={this.props.theme.RegionPicker}>
      {this.renderCountryRadio()}
      {this.renderLanguageRadio()}
    </div>;
  }

  renderCountryRadio () {
    let showAllButtonTheme = (this.props.collapse.includes(RegionPicker.collapsibles.COUNTRY_LIST))
      ? ''
      : this.props.theme.Hidden;
    return (<div className={`${this.props.theme.CountryPicker} ${(this.props.useFlags)
      ? `${this.props.theme.F16} ${this.props.theme.FlagPicker}`
      : ''}`}>
      <RadioGroupInput
        {...this.inputProps('country')}
        choices={this.props.countryCodes.map(countryCode => ({
          label: getLabelFromCountryCode(countryCode),
          value: countryCode,
          classNames: ['Flag', countryCode.toLowerCase()],
        }))}
        onChange={ev => this.updateCountry(ev)}
        value={this.props.country}
        theme={this.props.theme} />
      <a className={`${this.props.theme.ShowAll} ${showAllButtonTheme}`}
         onClick={ev => this.toggleCollapse(ev, RegionPicker.collapsibles.COUNTRY_LIST)}>
        Show all
      </a>
    </div>);
  }

  renderLanguageRadio () {
    return (<div className={`${this.props.theme.LanguagePicker}`}>
      <RadioGroupInput
        choices={this.props.languages.map(language => ({
          value: language,
          label: getLabelFromLanguage(language),
        }))}
        {...this.inputProps('flagChoice')}
        value={this.props.readingLanguage}
        onChange={ev => this.updateReadingLanguage(ev)}
        theme={this.props.theme} />
    </div>);
  }

  renderRegionPicker () {
    switch (this.props.type) {
      case RegionPicker.renderTypes.MAP_RADIO:
        return this.renderMapRadio();
      case RegionPicker.renderTypes.RADIO_DROPDOWN:
        return this.renderRadioDropdown();
      case RegionPicker.renderTypes.DOUBLE_RADIO:
        return this.renderDoubleRadio();
      case RegionPicker.renderTypes.COUNTRY_RADIO:
        return <div className={this.props.theme.RegionPicker}>{this.renderCountryRadio()}</div>
      default:
        return [];
    }
  }

  render () {
    if (this.props.togglable) {
      return this.renderTogglable();
    } else {
      return this.renderRegionPicker();
    }
  }
}

RegionPicker.sortTypes = {
  ALPHABETICAL: 0,
  BEST_MATCH: 1,
  VALUE_LANGUAGE: 2,
  VALUE_ALWAYS_FIRST: 3,
};

RegionPicker.renderTypes = {
  MAP_RADIO: 0,
  RADIO_DROPDOWN: 1,
  DOUBLE_RADIO: 2,
  COUNTRY_RADIO: 3,
};

RegionPicker.collapsibles = {
  COUNTRY_LIST: 0,
};

RegionPicker.propTypes = {
  type: PropTypes.oneOf(Object.values(RegionPicker.renderTypes)),
  mapSettings: PropTypes.object,
  mapSettingsOverride: PropTypes.object,
  readingLanguage: PropTypes.string,
  country: PropTypes.string,
  countryCodes: PropTypes.array,
  onUpdateCountry: PropTypes.func,
  onUpdateReadingLanguage: PropTypes.func,
  useFlags: PropTypes.bool,
  togglable: PropTypes.bool,
  sortBy: PropTypes.array,
  showPlaceholder: PropTypes.bool,
  preferredLanguages: PropTypes.array,
  languages: PropTypes.array,
  collapse: PropTypes.array,
};

RegionPicker.defaultProps = {
  type: RegionPicker.renderTypes.MAP_RADIO,
  mapSettingsOverride: {
    map: 'world_mill_en',
    regionsSelectable: true,
    regionsSelectableOne: true,
    backgroundColor: 'transparent',
    onRegionTipShow: function (e, el, code) {
      e.preventDefault();
    },
  },
  theme: defaultTheme,
  mapSettings: {},
  languages: [],
  saveImmediately: false,
  useFlags: false,
  sortByBestMatch: false,
  showPlaceholder: false,
  togglable: false,
  sortBy: [],
  collapse: [],
};

themeable(RegionPicker, {
  classes: [
    'Checked',
    'CountryPicker',
    'DropdownContainer',
    'DropdownFlag',
    'F16',
    'F32',
    'Flag',
    'FlagPicker',
    'Hidden',
    'Icon',
    'InputRadio',
    'LanguagePicker',
    'MapPicker',
    'RegionPicker',
    'RegionPickerActive',
    'RegionPickerInactive',
    'RegionPickerPopup',
    'RegionPickerPopupWrapper',
    'RegionPickerToggle',
    'Selected',
    'ShowAll',
    'WorldMap',
    // Countries taken from flags[size].less
    'ad', 'ae', 'af',
    'ag', 'ai', 'al',
    'am', 'an', 'ao',
    'aq', 'ar', 'as',
    'at', 'au', 'aw',
    'az', 'ba', 'bb',
    'bd', 'be', 'bf',
    'bg', 'bh', 'bi',
    'bj', 'bm', 'bn',
    'bo', 'br', 'bs',
    'bt', 'bw', 'by',
    'bz', 'ca', 'cg',
    'cf', 'cd', 'ch',
    'ci', 'ck', 'cl',
    'cm', 'cn', 'co',
    'cr', 'cu', 'cv',
    'cy', 'cz', 'de',
    'dj', 'dk', 'dm',
    'do', 'dz', 'ec',
    'ee', 'eg', 'eh',
    'er', 'es', 'et',
    'fi', 'fj', 'fm',
    'fo', 'fr', 'ga',
    'gb', 'gd', 'ge',
    'gg', 'gh', 'gi',
    'gl', 'gm', 'gn',
    'gp', 'gq', 'gr',
    'gt', 'gu', 'gw',
    'gy', 'hk', 'hn',
    'hr', 'ht', 'hu',
    'id', 'mc', 'ie',
    'il', 'im', 'in',
    'iq', 'ir', 'is',
    'it', 'je', 'jm',
    'jo', 'jp', 'ke',
    'kg', 'kh', 'ki',
    'km', 'kn', 'kp',
    'kr', 'kw', 'ky',
    'kz', 'la', 'lb',
    'lc', 'li', 'lk',
    'lr', 'ls', 'lt',
    'lu', 'lv', 'ly',
    'ma', 'md', 'me',
    'mg', 'mh', 'mk',
    'ml', 'mm', 'mn',
    'mo', 'mq', 'mr',
    'ms', 'mt', 'mu',
    'mv', 'mw', 'mx',
    'my', 'mz', 'na',
    'nc', 'ne', 'ng',
    'ni', 'nl', 'no',
    'np', 'nr', 'nz',
    'om', 'pa', 'pe',
    'pf', 'pg', 'ph',
    'pk', 'pl', 'pr',
    'ps', 'pt', 'pw',
    'py', 'qa', 're',
    'ro', 'rs', 'ru',
    'rw', 'sa', 'sb',
    'sc', 'sd', 'se',
    'sg', 'si', 'sk',
    'sl', 'sm', 'sn',
    'so', 'sr', 'st',
    'sv', 'sy', 'sz',
    'tc', 'td', 'tg',
    'th', 'tj', 'tl',
    'tm', 'tn', 'to',
    'tr', 'tt', 'tv',
    'tw', 'tz', 'ua',
    'ug', 'us', 'uy',
    'uz', 'va', 'vc',
    've', 'vg', 'vi',
    'vn', 'vu', 'ws',
    'ye', 'za', 'zm',
    'zw',
  ],
});



// WEBPACK FOOTER //
// ./lib/rlink-regions/components/RegionPicker.jsx